import React from 'react';
import {
  Avatar,
  Badge,
  ListItemButton,
  Typography,
  Box,
} from '@mui/material';
import useInterveneSx from '../hooks/useInterveneSx';
import useInterveneTheme from '../hooks/useInterveneTheme';
import {
  formatRelativeTime,
  getMessagePreview,
} from '../utils/getMessagePreview';
import {
  getConversationAvatarInitial,
  getConversationDisplayName,
} from '../utils/conversationIdentity';
import { getConversationAvatarTone } from '../utils/getConversationAvatarTone';
import { USER_LIST_BADGE_MODE } from '../utils/userListBadgeRules';
import SessionCountdownBadge from './SessionCountdownBadge';

export default function UserListItem({ user, isSelected, badgeMode, tabValue, onSelect }) {
  const styles = useInterveneSx().userListItem;
  const { chat } = useInterveneTheme();
  const userListTokens = chat.userList || {};
  const displayName = getConversationDisplayName(user);
  const avatarInitial = getConversationAvatarInitial(user);
  const lastMsg = getMessagePreview(user.last_message);
  const timeLabel = formatRelativeTime(user.last_message?.created_at || user.updated_at);
  const isLive = user.intervene && user.session_start;
  const unreadCount = Number(user.not_read_count) || 0;
  const avatarSource = user.profile_pic || '';
  const avatarTone = getConversationAvatarTone(chat, { selected: isSelected });

  return (
    <ListItemButton
      onClick={() => onSelect(user)}
      selected={isSelected}
      sx={styles.button}
    >
      <Box sx={styles.avatarWrap}>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          variant="dot"
          sx={{
            '& .MuiBadge-badge': {
              ...styles.badgeDot,
              bgcolor: isLive ? chat.online : 'transparent',
              border: isLive
                ? `2px solid ${userListTokens.avatarBadgeBorder || chat.paper}`
                : 'none',
              right: userListTokens.presenceOffset || 4,
              bottom: userListTokens.presenceOffset || 4,
            },
          }}
        >
          <Avatar
            src={avatarSource}
            sx={{
              ...styles.avatar,
              bgcolor: avatarTone.background,
              color: avatarTone.foreground,
            }}
          >
            {!avatarSource && avatarInitial}
          </Avatar>
        </Badge>
      </Box>

      <Box sx={styles.content}>
        <Box sx={styles.primaryRow}>
          <Typography
            variant="subtitle2"
            noWrap
            title={displayName}
            sx={styles.name}
          >
            {displayName}
          </Typography>
          <Box sx={styles.metaStack}>
            {badgeMode === USER_LIST_BADGE_MODE.EXPIRED && (
              <Box component="span" sx={styles.expiredChip}>
                Expired
              </Box>
            )}
            {badgeMode === USER_LIST_BADGE_MODE.TIMER && (
              <SessionCountdownBadge user={user} tabValue={tabValue} dense />
            )}
            {/* {timeLabel && (
              <Typography variant="caption" component="span" sx={styles.timeLabel}>
                {timeLabel}
              </Typography>
            )} */}
          </Box>
        </Box>

        <Box sx={styles.secondaryRow}>
          <Typography variant="caption" noWrap sx={styles.preview}>
            {lastMsg}
          </Typography>
          {unreadCount > 0 && (
            <Box component="span" sx={styles.unreadBadge}>
              {unreadCount > 99 ? '99+' : unreadCount}
            </Box>
          )}
        </Box>
      </Box>
    </ListItemButton>
  );
}
